import { useSubscription } from '../contexts/SubscriptionContext';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook para verificar se o usuário tem acesso à funcionalidade de vídeo
 * Acesso é liberado apenas para plano intermediário (medium) ou superior
 */
export function useHasVideoAccess() {
  const { subscription } = useSubscription();
  const { user } = useAuth();

  const hasAccess = 
    user !== null &&
    subscription !== null &&
    subscription.status === 'active' &&
    (subscription.planType === 'medium' || 
     subscription.planType === 'advanced' || 
     subscription.planType === 'monthly');

  return {
    hasAccess,
    planType: subscription?.planType || null,
    subscriptionStatus: subscription?.status || null,
  };
}




